export const passZippedFile = async (res: Response) => {
  const buffer = await res.arrayBuffer();
  const bytes = new Uint8Array(buffer);
  const isGzipped = bytes[0] === 0x1f && bytes[1] === 0x8b; // Gzipped files start with 1f 8b

  if (isGzipped) {
    // Decompress gzipped file
    const ds = new (globalThis as any).DecompressionStream("gzip");
    const decompressedStream = new Response(buffer).body.pipeThrough(ds);
    const text = await new Response(decompressedStream).text();
    return JSON.parse(text);
  }

  const text = new TextDecoder().decode(buffer);
  return JSON.parse(text);
};
